<template>  
    <v-container fluid>
        
        <v-layout row wrap >          
            <v-flex xs12>
                <h2> Firmenübersicht </h2>
            </v-flex>
                
        </v-layout>    
        
        <v-container fluid grid-list-xs fill-height>
            <v-layout row wrap fill-height>

                <v-flex xs12 md6 lg4 v-for="firma in filteredFirmen" v-bind:key="firma.id">                          
                    <single-firmen v-on:toDestroy="onDestroy(firma.id)" v-bind:fa="firma"></single-firmen>                                                                        
                </v-flex>   

           </v-layout>
        </v-container>
    </v-container>
    
</template>

<script>

import searchMixin from '../../mixins/searchMixin'
import singleFirmen from './singleFirmen.vue'
import { mapGetters } from 'vuex'

export default {
    components: {
        'single-firmen': singleFirmen
    },
        
    mounted: function() {
        this.$store.dispatch('setFirmen')
    },
    computed: {
        ...mapGetters([            
            'loading',
            'isAuth',
            'authUser',
            'firmen'
    
        ]),
        
        
        
    },
    methods: {
        
        onDestroy: function(id) {
            this.$store.commit('setMessagebar', false)       
             this.$store.dispatch('deleteFirma', id).then(()=>{
                this.$store.dispatch('setPreFilteredMarken',[])
                this.$store.dispatch('setPreFilteredFirmen',[])
             })
             this.$store.commit('setMessagebar', true)       
        }
    },    
    
    mixins: [
        searchMixin
    ]
    
}
</script>

<style>
    
    
</style>



// WEBPACK FOOTER //
// showFirmen.vue?7871749d